<gbc-tile [title]="'igrid-installation-module-configuration-form.title' | translate">
  <form [formGroup]="form">
    @if ((modules | async)?.length) {
      @for (module of modules | async; track module) {
        <div>
          <div class="module-name-container">
            <b>{{ module.name }}</b>
          </div>
          <json-editor [options]="makeOptions()" [formControlName]="module.name"></json-editor>
        </div>
      }
    } @else {
      {{ 'NO MODULES' | translate }}
    }

  </form>
</gbc-tile>
